import { ExperimentClient } from './types';

export const EXPERIMENTS_SESSION_ID = 'session_experiment_id';
export const EXPERIMENT_HEADER = 'experiments';
export const EXPERIMENT_COOKIE = 'ss_experiment_web2';
export const EXPERIMENT_CLIENT_COOKIE = 'ss_experiment_client_web2';

export const DEFAULT_EXPERIMENT_CLIENT: ExperimentClient = {
  path: '',
  experiments: [],
  metadata: { ip: '', ids: [], sessionId: '' },
};
